/*
 * @Description: 
 * @Author: invoker
 * @Email: pengdanfeng@nnuo.com
 * @Date: 2022-04-27 11:16:24
 * @LastEditors: invoker
 * @LastEditTime: 2022-05-27 11:49:03
 * @FilePath: \merchant-platform\src\api\axiosRequestNew.js
 */
import axios from "axios";
import { Message } from "element-ui";
import qs from "qs";
import { indexUrl, redirectUrl } from "./urlConfig";
import { clearLocalStorage } from "@api/utils";

const axiosInstance = axios.create({
  baseURL: `//${window.location.host}/juheCustomer/`,
  withCredentials: true,
  timeout: 30000
});
axiosInstance.interceptors.request.use(
  function (config) {
    // 在发送请求之前做些什么
    if (config.data) {
      if (typeof config.data === "string") {
        config.data += `&_=${Date.parse(new Date())}`;
      } else {
        config.data["_"] = Date.parse(new Date());
        if (!config.headers.isRequestPayload)
          config.data = qs.stringify(config.data);
      }
    } else if (/\?|\=/g.test(config.url)) {
      config.url = config.url + `&_=${Date.parse(new Date())}`;
    }

    return config;
  },
  function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);
export const urlDataExtend = url => {
  return `${window.location.protocol}//${window.location.host}/juheExtend/${url}`;
};
axiosInstance.interceptors.response.use(
  res => {
    if (res.data.code == "210") {
      sessionStorage.clear();
      clearLocalStorage(["urlConfig", "firstLogin"]);
      window.location.href = `${indexUrl}/Contents/usercenter/allow/login/login.jsp?redirecturl=${redirectUrl}`;
    } else {
      res.data._success = parseInt(res.data.code) === 200;
      if (res.data.code !== 200) {
        !res.config.headers.disableMessage &&
          Message.error({
            duration: 1500,
            message: res.data.message || res.data.msg || "请求出错"
          });
      }
      return res.data;
    }
  },
  err => {
    console.log(err);

    // 如果错误类型为取消请求，则不需要报错
    if (!axios.isCancel(err)) {
      !err.config.headers.disableMessage &&
        Message.error({
          duration: 1500,
          message: err.message || "请求出错"
        });
    }
  }
);
export default axiosInstance;
